<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 23">
    <path
      fill="currentColor"
      fill-rule="nonzero"
      d="M16 17.25a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m-8 0a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m8 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-8 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M3.062 3.25l.158.54 1.009 3.46h16.732l-.233.932-2 8-.142.568H5.437l-.157-.54-2.333-8-.28-.96-.73-2.501L0 4.75v-1.5zm15.977 5.5H4.666l1.896 6.5h10.852zM19.75 0v2.25H22v1.5h-2.25V6h-1.5V3.75H16v-1.5h2.25V0z"
    />
  </svg>
</template>
